<!-- LARGE  desktop, breadcrumb menu  -->
<app-breadcrumb class="d-none d-lg-flex" [breadCrumbs]="settingBreadCrumbs"></app-breadcrumb>

<!-- MOBILE, dropdown menu -->
<div class="d-lg-none ms-1 me-2 me-md-2 mx-lg-5 mt-lg-5">
    <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-6">
        <div class="d-inline-flex ms-2 ms-md-3">
        </div>
        <span class="float-end d-flex d-block">
            <button type="button" class="btn btn-sm btn-secondary me-2 me-md-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-list"></i>
            </button>
            <div class="dropdown">
                <ul class="dropdown-menu dropdown-menu-end">
                    <li><a class="dropdown-item" routerLink="/dashboard"><span
                                translate>Settings.BackToDashboard</span></a></li>
                    <li><a class="dropdown-item" routerLink="/settings/account/profile"><span
                                translate>Settings.Profile</span></a></li>
                    <li><a class="dropdown-item" routerLink="/settings/account/signature"><span
                                translate>Settings.Signature</span></a></li>
                    <li><a class="dropdown-item" routerLink="/settings/account/security"><span
                                translate>Settings.Security</span></a></li>
                    <li><a class="dropdown-item" routerLink="/settings/account/roles"><span
                                translate>Settings.Roles</span></a></li>
                    <li><a class="dropdown-item" routerLink="/settings/account/workgroups"><span
                                translate>Settings.Workgroups</span></a></li>
                </ul>
            </div>
        </span>
    </div>
</div>